export const isValidHttpUrl = (url) => {
  if (!url?.trim()) {
    return false;
  }

  try {
    const parsedUrl = new URL(url.trim());
    return parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:";
  } catch {
    return false;
  }
};
